import React, { useEffect, useState } from 'react';
import { Menu, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/Sheet';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToQuote = () => {
    setMenuOpen(false);
    document.getElementById('quote')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-primary ${isScrolled ? 'shadow-lg py-3' : 'py-4 lg:py-6'}`} data-id="element-59">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-60">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 z-50" data-id="element-61">
          <span className="font-heading font-bold text-2xl tracking-tight text-white" data-id="element-62">
            PRESSURE PERFECT
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-63">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-accent font-medium transition-colors text-sm uppercase tracking-wider" data-id="element-64">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-65">
          <a href="tel:+1234567890" className="flex items-center gap-2 text-white hover:text-accent transition-colors font-bold text-lg" data-id="element-66">
            <Phone className="w-5 h-5" data-id="element-67" />
            (555) 123-4567
          </a>
          <Button onClick={scrollToQuote} className="bg-accent hover:bg-accent/90 text-white font-bold px-6" data-id="element-68">
            Get a Free Quote
          </Button>
        </div>

        {/* Mobile Nav */}
        <div className="lg:hidden flex items-center gap-4" data-id="element-69">
          <a href="tel:+1234567890" className="text-white p-2" data-id="element-70">
            <Phone className="w-5 h-5" data-id="element-71" />
          </a>
          <Sheet open={menuOpen} onOpenChange={setMenuOpen} data-id="element-72">
            <SheetTrigger asChild data-id="element-73">
              <Button variant="ghost" size="icon" className="text-white hover:bg-white/10" data-id="element-74">
                <Menu className="w-6 h-6" data-id="element-75" />
                <span className="sr-only" data-id="element-76">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" style={{
            backgroundColor: '#0F1C2E'
          }} className="fixed inset-0 z-[100] w-full h-full max-w-none text-white border-0 p-6 flex flex-col transform-gpu" data-id="element-77">
              <SheetHeader className="text-left mb-10 mt-2" data-id="element-78">
                <SheetTitle className="text-white font-heading text-3xl" data-id="element-79">
                  Menu
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-8 flex-1" data-id="element-80">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMenuOpen(false)} className="text-3xl font-heading font-bold text-white hover:text-accent transition-colors uppercase tracking-wide" data-id="element-81">
                    {link.name}
                  </a>)}
                <div className="h-px bg-white/10 my-2" data-id="element-82" />
                <Button onClick={scrollToQuote} className="bg-accent hover:bg-accent/90 text-white font-bold w-full h-14 text-lg mt-auto" data-id="element-83">
                  Get a Free Quote
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}